// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_point_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WeatherForecastPointService } from "./weather_forecast_point_service_pb";

/**
 * ListWeatherForecastPoints returns the *effective* point for all 10 areas
 * (AC-WFP-007: the saved selection when it is still a candidate, otherwise
 * the area default; selection_state says which) together with the
 * system-fixed candidate list per area. The frontend renders location_name
 * as-is and does not re-derive the fallback.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherForecastPointService.ListWeatherForecastPoints
 */
export const listWeatherForecastPoints = WeatherForecastPointService.method.listWeatherForecastPoints;

/**
 * UpdateWeatherForecastPoints updates the weather-forecast point
 * selection for one or more areas in a single atomic transaction
 * (AC-WFP-004). Optimistic locking is applied per row via
 * expected_updated_at: if the stored updated_at differs from the
 * baseline the server returns ABORTED (AC-WFP-005). A location_name that
 * is not in the system-fixed candidate list is rejected with
 * INVALID_ARGUMENT (AC-WFP-009). organization_id is resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherForecastPointService.UpdateWeatherForecastPoints
 */
export const updateWeatherForecastPoints = WeatherForecastPointService.method.updateWeatherForecastPoints;
